import { Box, Tooltip, Typography } from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery'
import { CalendarPicker, PickersDay } from '@mui/x-date-pickers'
import React from 'react'
import Carousel from 'react-material-ui-carousel'
import { connect } from 'react-redux'
import {
  Operations as LayoutOperations,
  operations as layoutOperations
} from 'states/dux/layout/operations'
import { Payload as LayoutPayload } from 'states/dux/layout/types'
import {
  Operations as ThemeOperations,
  operations as themeOperations
} from 'states/dux/theme/operations'
import { Payload as ThemePayload } from 'states/dux/theme/types'
import State from 'states/types'
import { NivosEvent } from 'types/nivos-event'
import { datesAreOnSameDay, mapOperationsToDispatchProps } from 'utils/common'

interface StateProps {
  theme: ThemePayload
  layout: LayoutPayload
}

interface DispatchProps {
  operations: {
    theme: ThemeOperations
    layout: LayoutOperations
  }
}

type AppProps = StateProps & DispatchProps

const ImportantDatesFC: React.FC<any> = (props: AppProps) => {
  const { layout, theme } = props
  const isMobileView = useMediaQuery('(max-width:600px)')
  const tomorrow = new Date()
  tomorrow.setDate(tomorrow.getDate() + 1)

  const events: NivosEvent[] = [
    {
      eventName: 'Coffee Promo!',
      date: new Date(),
      description: 'USE COFFEE25 CODE ON CHECKOUT'
    },
    {
      eventName: 'Free Pool Admission',
      date: new Date(),
      description:
        'Free pool admission for Nivos Residents (Valid for one day only)'
    },
    {
      eventName: 'Elevator #2 Maintenance',
      date: tomorrow,
      description:
        'Please be advised elevator #2 will not be available on this day.'
    }
  ]

  const dateInSchedule = (date: Date): NivosEvent[] => {
    return events.filter(data => datesAreOnSameDay(data.date, date))
  }

  const DateCarouselItem: React.FC<{ eventItem: NivosEvent }> = props => {
    const { eventItem } = props

    return (
      <Box
        display={'flex'}
        alignItems={'center'}
        width={isMobileView ? '85vw' : 395}
        height={75}
        border={1}
        borderColor={theme.secondaryColor}
        borderRadius={4}
        sx={{
          cursor: 'pointer',
          transition: '0.5s',
          ':hover': {
            borderRadius: 8
          }
        }}
      >
        <Box paddingLeft={2}>
          <Typography variant={'h5'}>{eventItem.date.getDate()}</Typography>
          <Typography variant={'h5'}>
            {eventItem.date.toLocaleString('default', { month: 'short' })}
          </Typography>
        </Box>
        <Box
          paddingX={1}
          borderRight={1}
          height={'56px'}
          color={theme.secondaryColor}
        />
        <Box
          paddingRight={1}
          borderLeft={1}
          height={'56px'}
          color={theme.secondaryColor}
        />
        <Box height={0.8}>
          <Typography
            variant={'h6'}
            maxWidth={250}
            maxHeight={65}
            overflow={'auto'}
          >
            {eventItem.eventName}
          </Typography>
        </Box>
      </Box>
    )
  }

  return (
    <Box display={'flex'} flexDirection={'column'} alignItems={'center'}>
      <Typography variant={isMobileView ? 'h4' : 'h3'}>
        {layout.language.translations.importantDates}
      </Typography>
      <CalendarPicker
        date={new Date()}
        onChange={() => null}
        renderDay={(day, selectedDays, pickersDayProps) => {
          const dateScheduled = dateInSchedule(day)
          if (dateScheduled.length > 0) {
            return (
              <Tooltip
                key={pickersDayProps.key}
                title={
                  <Box>
                    {dateScheduled.map((event, index) => (
                      <Typography
                        gutterBottom
                        color={theme.primaryColor}
                        key={index}
                      >
                        <strong>{event.eventName}</strong> -{' '}
                        <small>{event.description}</small>
                      </Typography>
                    ))}
                  </Box>
                }
                placement={'top'}
                arrow
              >
                <PickersDay {...pickersDayProps} selected={true} />
              </Tooltip>
            )
          } else {
            return <PickersDay {...pickersDayProps} selected={false} />
          }
        }}
      />
      <Carousel
        autoPlay
        navButtonsAlwaysInvisible
        stopAutoPlayOnHover={false}
        interval={3250}
        animation={'slide'}
        sx={{ width: isMobileView ? '86vw' : 402, height: 110 }}
      >
        <DateCarouselItem eventItem={events[0]} />
        <DateCarouselItem eventItem={events[1]} />
        <DateCarouselItem eventItem={events[2]} />
      </Carousel>
    </Box>
  )
}

const mapStateToProps = (state: State): StateProps => {
  return {
    theme: state.theme,
    layout: state.layout
  }
}

const mapDispatchToProps = mapOperationsToDispatchProps({
  theme: themeOperations,
  layout: layoutOperations
})

const ImportantDates = connect(
  mapStateToProps,
  mapDispatchToProps
)(ImportantDatesFC) as React.FC

export default ImportantDates
